import { render, staticRenderFns } from "./Morava.vue?vue&type=template&id=0a8670d9&scoped=true&"
import script from "./Morava.vue?vue&type=script&lang=js&"
export * from "./Morava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8670d9",
  null
  
)

export default component.exports